import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  height: 100%;
  padding: 8px 6px 16px 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TextContent = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Text = styled.span`
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
`

export const YearButton = styled.button`
  background: none;
  border: none;
  padding: 5px 3px 0 3px;
  cursor: pointer;
  position: relative;
`

export const MonthsButtonBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const MonthButton = styled.button`
  width: 24px;
  height: 24px;
  padding-top: 5px;
  background: none;
  border: none;
  cursor: pointer;
`

export const YearBoxOpen = styled(Box)`
  ${({ theme }) => css`
    width: 104px;
    max-height: 135px;
    position: absolute;
    right: -40px;
    background: red;
    overflow-y: auto;
    border-radius: 4px;
    background: ${theme.colors.lightest};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 10;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;

    /* Scrollbar styles aligned with Select's MenuPaper */
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.background.hover};
      border-radius: 8px;
      transition: background-color 0.3s ease;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: ${theme.colors.background.hover};
    }

    scrollbar-width: thin;
    scrollbar-color: ${theme.colors.background.hover} transparent;
  `}
`

export const YearButtonOpen = styled.button<{ $isSelected?: boolean }>`
  ${({ theme, $isSelected }) => css`
    width: 64px;
    height: 32px;
    font-size: 16px;
    border-radius: 4px;
    border: none;
    padding: 8px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${$isSelected ? theme.colors.primary : 'transparent'};
    color: ${$isSelected ? theme.colors.lightest : theme.colors.secondary};
    font-weight: 400;
    cursor: pointer;

    &:hover {
      transition: all ease 0.3s;
      background: ${$isSelected ? theme.colors.primary : theme.colors.lightest};
    }
  `}
`
